// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nq-6";
export var imgContainer = "_nq-3";
export var menuIcon = "_nq-5";
export var pillWrapper = "_nq-2";
export var pillsContainer = "_nq-1";
export var subscriptionCard = "_nq-0";
export var subscriptionLogo = "_nq-4";